export default __webpack_public_path__ + "static/media/Soles of the Ghost of the Veldt.e1464994.jpg";